module.exports = __webpack_public_path__ + "media/images/oak/banners/banner-1-mobile-c141229b7c64c05cd75954d9c1c9c4ef.jpg";